import { render, staticRenderFns } from "./AppOnboardingStepper.vue?vue&type=template&id=20cfcd8b&scoped=true&"
import script from "./AppOnboardingStepper.vue?vue&type=script&lang=ts&"
export * from "./AppOnboardingStepper.vue?vue&type=script&lang=ts&"
import style0 from "./AppOnboardingStepper.vue?vue&type=style&index=0&id=20cfcd8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfcd8b",
  null
  
)

export default component.exports